import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import styles from "./styles.module.css";

import { isRTL } from "src/utils/global";


import Img1 from "src/assets/images/home/gallery/1.webp";
import Img2 from "src/assets/images/home/gallery/2.webp";
import Img3 from "src/assets/images/home/gallery/3.webp";
import Img4 from "src/assets/images/home/gallery/4.webp";
import Img5 from "src/assets/images/home/gallery/5.webp";
import Img6 from "src/assets/images/home/gallery/6.webp";



import { Title } from "src/components";
import { Element } from "react-scroll";






const Gallery = () => {
    const { t, i18n } = useTranslation("home");

    const galleryImages = [
        { id: 1, src: Img1, alt: t("gallery.images.img1") },
        { id: 2, src: Img2, alt: t("gallery.images.img2") },
        { id: 3, src: Img3, alt: t("gallery.images.img3") },
        { id: 4, src: Img4, alt: t("gallery.images.img4") },
        { id: 5, src: Img5, alt: t("gallery.images.img5") },
        { id: 6, src: Img6, alt: t("gallery.images.img6") }
    ];

    return (
        <Element name="gallery" className={`${styles.sectionContainer} ${isRTL() && styles.rtl}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12 m-auto">
                        <div className={styles.content}>
                            <div className={styles.title}>
                                <Title lgTitle={t("gallery.title.lg")} smTitle={t("gallery.title.sm")} />
                            </div>
                            <Swiper
                                key={i18n.language}
                                modules={[Autoplay]}
                                spaceBetween={20}
                                slidesPerView="auto"
                                loop={true}
                                autoplay={{
                                    delay: 0,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                speed={3000}
                                allowTouchMove={true}
                                dir={isRTL() ? "rtl" : "ltr"}
                                className={styles.swiper}
                            >
                                {galleryImages.map(({ id, src, alt }) => (
                                    <SwiperSlide key={id} className={styles.imgCon}>
                                        <img src={src} alt={alt} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>



                        </div>
                    </div>

                </div>
            </div>
        </Element>
    );
};

export default Gallery;